var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_695_10",
    "data-name": "Komponente 695 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_358",
    "data-name": "Ellipse 358",
    fill: "#0d1015",
    stroke: "#31b9b5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(7.83 9.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_558",
    "data-name": "Pfad 558",
    d: "M21.94,9.94a1.5,1.5,0,1,1,2.142,2.1L16.1,22.02a1.5,1.5,0,0,1-2.16.04l-5.29-5.292a1.5,1.5,0,1,1,2.12-2.12l4.188,4.186L21.9,9.984a.472.472,0,0,1,.04-.044Z",
    transform: "translate(-8.171 -9.49)",
    fill: "#35b9b5",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.fcf4e0702f6b7836458e6fcc00c0a16d.svg";
export { ForwardRef as ReactComponent };